import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface RecipientDetailsProps {
  isShowRecipientDetails?: boolean;
  toggleDetails: () => void;
  recipient: RecipientResponse | null;
}

export const RecipientDetails = (props: RecipientDetailsProps) => {
  const { t } = useTranslation('payments');

  return (
    <div className='mt-3 flex w-full flex-col'>
      <div className='flex cursor-pointer gap-2' onClick={props.toggleDetails}>
        <Text>{t('recipient.details.title')}</Text>
        <Icon icon={<ChevronIcon />} className={cn('-rotate-90 transition duration-200', props.isShowRecipientDetails && 'rotate-90')} />
      </div>
      {props.isShowRecipientDetails && props.recipient && (
        <div className='mt-3 flex gap-10 max-[1024px]:flex-wrap'>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              {t('recipient.details.fields.iban')}
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.iban}
            </Text>
          </div>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              {t('recipient.details.fields.bankName')}
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.bankName}
            </Text>
          </div>
          <div className='flex flex-col'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              {t('recipient.details.fields.bicSwiftCode')}
            </Text>
            <Text weight='semibold' size='sm'>
              {props.recipient.bic}
            </Text>
          </div>
          {props.recipient.firstName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                {t('recipient.details.fields.firstName')}
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.firstName}
              </Text>
            </div>
          )}
          {props.recipient.lastName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                {t('recipient.details.fields.lastName')}
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.lastName}
              </Text>
            </div>
          )}
          {props.recipient.companyName && (
            <div className='flex flex-col'>
              <Text size='sm' color={ColorsEnum.Secondary}>
                {t('recipient.details.fields.companyName')}
              </Text>
              <Text weight='semibold' size='sm'>
                {props.recipient.companyName}
              </Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
